module.exports = __webpack_public_path__ + "img/line3-blue.1065b458.png";